webpackJsonp([94],{

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 2971:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__settins_rules_js__ = __webpack_require__(5378);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      formRules: __WEBPACK_IMPORTED_MODULE_0__settins_rules_js__["a" /* formRules */],
      form: {
        oldPassword: '',
        username: '',
        newPassword: '',
        newPasswordRpt: '',
        isBeforLogin: false
      }
    };
  },

  computed: Vuex.mapState({
    user: function user(state) {
      return state.login.user;
    }
  }),
  created: function created() {
    this.form.username = this.user.name;
    this.isBeforLogin = this.$route.meta.isBeforLogin;
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBeforLogin) {
      this.$store.commit('LOGOUT');
      this.$router.push('/login');
    }
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      if (!this.isStrongPwd(this.form.newPassword)) {
        this.$message.error('密码必须大于等于8位，且必须包含大小写字母、数字、特殊符号 4类内容');
        return;
      }
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          request.common('changePassword', {
            'originPassword': _this.form.oldPassword,
            'newPassword': _this.form.newPassword,
            'newPassword_confirmation': _this.form.newPasswordRpt
          }).then(function (res) {
            _this.$alert(_this.$route.meta.title + '成功，请重新登陆', '提示', { type: 'success' }).finally(function () {
              _this.$store.commit('LOGOUT');
              _this.$router.push(filter.loginPath('/'));
            });
          });
        } else {
          _this.$message.error('提交内容填写不正确！');
        }
      });
    },
    isStrongPwd: function isStrongPwd(pwd) {
      return pwd.length >= 8 && [/[\u0020-\u002F\u003A-\u0040\u005B-\u0060\u007B-\u007E]/, /[0-9]/, /[a-z]/, /[A-Z]/].map(function (regex) {
        return regex.test(pwd);
      }).reduce(function (result, current) {
        return result && current;
      }, true);
    }
  }
});

/***/ }),

/***/ 328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__ = __webpack_require__(2971);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aae927f0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__ = __webpack_require__(5379);
function injectStyle (ssrContext) {
  __webpack_require__(5376)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aae927f0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 5376:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5377);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("0270a4c9", content, true, {});

/***/ }),

/***/ 5377:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "#app{background-color:#eff0f4}", "", {"version":3,"sources":["/workspace/src/views/settings/pages/ChangePassword.vue"],"names":[],"mappings":"AACA,KACE,wBAA0B,CAC3B","file":"ChangePassword.vue","sourcesContent":["\n#app {\n  background-color: #eff0f4;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5378:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var formRules = {
  oldPassword: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入旧密码', 'string'))],
  newPassword: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入新密码', 'string'))],
  newPasswordRpt: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请重复输入新密码', 'string'))]
};

/***/ }),

/***/ 5379:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],style:({ 'padding' : _vm.isBeforLogin ? '30px' : '0px'})},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v("\n      "+_vm._s(_vm.$route.meta.title)+"\n    ")]),_vm._v(" "),(!_vm.isBeforLogin)?_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("设置")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("修改密码")])],1):_vm._e()],1),_vm._v(" "),_c('layout-panel',{attrs:{"show-header":false}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"label-width":"150px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[(_vm.$route.query['showDefaultPasswordHint'])?_c('el-alert',{staticStyle:{"margin-bottom":"25px"},attrs:{"type":"warning"}},[_vm._v("\n            请修改您的默认密码后进行其他操作\n          ")]):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"请输入旧密码","prop":"oldPassword"}},[_c('el-input',{attrs:{"type":"password"},model:{value:(_vm.form.oldPassword),callback:function ($$v) {_vm.$set(_vm.form, "oldPassword", $$v)},expression:"form.oldPassword"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"请输入新密码","prop":"newPassword"}},[_c('el-input',{attrs:{"type":"password"},model:{value:(_vm.form.newPassword),callback:function ($$v) {_vm.$set(_vm.form, "newPassword", $$v)},expression:"form.newPassword"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"请重新输入新密码","prop":"newPasswordRpt"}},[_c('el-input',{attrs:{"type":"password"},model:{value:(_vm.form.newPasswordRpt),callback:function ($$v) {_vm.$set(_vm.form, "newPasswordRpt", $$v)},expression:"form.newPasswordRpt"}})],1)],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","size":"mini","native-type":"submit"}},[_vm._v("保存\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/project-chart.440c8704889aa1c517cd.js